/**
 * Safe localStorage access that doesn't throw in storage-blocked contexts
 * (private mode, third-party cookie blocked iframes, partitioned storage policies).
 */

export function safeLocalStorageGet(name: string): string | null {
  try {
    return localStorage.getItem(name);
  } catch {
    return null;
  }
}

export function safeLocalStorageSet(name: string, value: string): void {
  try {
    localStorage.setItem(name, value);
  } catch {
    // no-op in storage-blocked contexts
  }
}

export function safeLocalStorageRemove(name: string): void {
  try {
    localStorage.removeItem(name);
  } catch {
    // no-op in storage-blocked contexts
  }
}